import {useAuthAxios} from 'hooks/api/useAuthAxios'

interface Result {
  id: number
}

export const useStartProcedureStatus = () => {
  const authAxios = useAuthAxios()

  return async (employeeId: string, procedureType: string, dateOn: string, status = 'draft', initialized?: boolean) => {
    return authAxios.post<Result>('/api/procedure_statuses', {
      employee_id: employeeId,
      procedure_type: procedureType,
      date_on: dateOn,
      status,
      initialized,
    })
  }
}
